import React from 'react'
import BaiscTable from '../tables/default-table'
import { useData } from '../../contexts/DataContext'
import { useAuth } from '../../contexts/AuthContext'

export default function PrintPaymentPlan({formData,topDetails,printingDocumentDate}) {

  const data=useData()
  const {selectedMicrocredit,user}=useAuth()
  let client=data._clients_list.filter(i=>i.id==formData.client_id)[0] || {}
  let micro=user.microcredits.filter(i=>i.id==selectedMicrocredit)[0]

  return (
    <div  print="true" className={`${data.printingDoc=="plan" ? '_print_div' :''} _plan_print  !text-[13px] w-full left-0 top-0 justify-center`} style={{zIndex:999}}>
    <style>
            {data.printingDoc=="plan" && `
                ._warranties_print *{
                    font-size: 12px !important;
                }
                table.paging,  table.paging thead td {
                    height: 180px !important;
                    border:0 !important;
                }
                table.paging,  table.paging, thead, td {
                    border:0 !important;
                }
                <link href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap" rel="stylesheet">
               *{
                   font-family: "Open Sans", sans-serif;
                }
            `}
            
        </style>

            <div class=" px-3">
            {micro.logo_filename && <div className="flex w-full mb-4">
                 <img className="h-[80px] mb-10" src={`${process.env.REACT_APP_BASE_URL}/uploaded_files/`+micro.logo_filename}/>
            </div>}

            <h2  className="text-center text-[22px] font-normal text-gray-500 py-2 !border-y !border-gray-400  mx-auto">Plano de pagamento</h2>
          
           </div>
           
              <div className="_print_content  bg-white">
                 <div className="w-full flex justify-between mt-3">
                      <div className="flex gap-x-2">
                             <div className="gap-y-1 flex-col flex items-end &>_span !text-[12px] !text-gray-500">
                                 <span className="flex h-[20px] items-center">Nome:</span>
                                 {client.name && <span className="flex h-[20px] items-center">Endereço:</span>}
                                 {client.email &&<span className="flex h-[20px] items-center">E-mail:</span>}
                                 <span className="flex h-[20px] items-center">Emissão:</span>
                             </div>
                             <div className="gap-y-1 flex-col flex !text-[13px]">
                                 <span className="flex h-[20px] items-center">{client.name}</span>
                                 {client.name && <span className="flex h-[20px] items-center">{client.address || '-'}</span>}
                                 {client.email &&<span className="flex h-[20px] items-center">{client.email || '-'}</span>}
                                 <span className="flex h-[20px] items-center">{new Date(printingDocumentDate).toISOString().split('T')[0]?.split('-')?.reverse()?.join('/')}</span>
                             </div>
                      </div>

                      {<div className="gap-y-1 flex-col flex !text-[13px]">
                                 <span className="flex h-[20px] items-center">{micro.name}</span>
                                 {micro.location && <span className="flex h-[20px] items-center">{micro.location}</span>}
                                 {micro.primary_contact && <span className="flex h-[20px] items-center">{micro.primary_contact || '-'} {micro.secondary_contact ? ' / '+micro.secondary_contact : ''}</span>}
                                 {micro.email && <span className="flex h-[20px] items-center">{micro.email}</span>}
                      </div>}

               </div>


                <div className="mt-8">


                     {formData.interest_calculation_method=="simple" && (
                          <div class="relative overflow-x-auto sm:rounded-lg">
                          <table class="w-full text-sm text-left rtl:text-right">
                              <thead class="text-[12px]  bg-white border-b border-black">
                                  <tr>
                                      {[
                                        '#',
                                        //'Data',
                                        'Valor',
                                        'Capital',
                                        'Juros',
                                        'Prazo de pagamento',
                                        'Divida',
                                      ].map((i,_i)=>(
                                          <th scope="col" class="px-6 py-3">
                                              {i}
                                          </th>
                                      ))}
                                  </tr>
                              </thead>
                              <tbody>
                               {(formData.installments || []).map((i,_i)=>(
                                 <tr class={`odd:bg-gray-100  even:bg-white ${_i==0 ? 'border-t !border-gray-400':''} __border-b __border-gray-200 text-[12px]`}>
                                 <td class="px-5 py-4">{_i+1}</td>
                                 {/**  <td class="px-5 py-4">{i.start.split('-')?.reverse()?.join('/')}</td> */}
                                 <td class="px-5 py-4">{data._cn((parseFloat(i.initial_amount || 0) - (parseFloat(topDetails.total_expenses) / parseInt(formData.number_of_installments))).toFixed(2))}</td>
                                 <td class="px-5 py-4">{data._cn((parseFloat(formData.disbursement_value || 0) / parseInt(formData.number_of_installments)).toFixed(2))}</td>
                                 <td class="px-5 py-4">{data._cn(((formData.fees || 0) / parseInt(formData.number_of_installments)).toFixed(2))}</td>
                                 <td class="px-5 py-4">{i.end.split('-')?.reverse()?.join('/')}</td>
                                 <td class="px-5 py-4">{data._cn(((i.total_to_pay) - (i.paid || 0)).toFixed(2))}</td>
                                 </tr>
                                ))}
                              </tbody>
                          </table>
                      </div>
                    )}


                    {formData.interest_calculation_method=="simple_old_version" && (
                          <div class="relative overflow-x-auto sm:rounded-lg">
                          <table class="w-full text-sm text-left rtl:text-right">
                              <thead class="text-[12px]  bg-white border-b border-black">
                                  <tr>
                                      {[
                                        '#',
                                        'Valor inicial',
                                        'Juros de mora',
                                        'Valor a pagar',
                                        'Pago',
                                        'Prazo de pagamento',
                                        'Divida',
                                      ].map((i,_i)=>(
                                          <th scope="col" class="px-6 py-3">
                                              {i}
                                          </th>
                                      ))}
                                  </tr>
                              </thead>
                              <tbody>
                               {(formData.installments || []).map((i,_i)=>(
                                 <tr class={`odd:bg-gray-100  even:bg-white ${_i==0 ? 'border-t !border-gray-400':''} __border-b __border-gray-200 text-[12px]`}>
                                 <td class="px-5 py-4">{_i+1}</td>
                                 <td class="px-5 py-4">{data._cn((i.initial_amount || 0).toFixed(2))}</td>
                                 <td class="px-5 py-4">{data._cn((i.late_payment_interest || 0).toFixed(2))}</td>
                                 <td class="px-5 py-4">{data._cn((i.total_to_pay).toFixed(2))}</td>
                                 <td class="px-5 py-4">{data._cn((i.paid || 0).toFixed(2))}</td>
                                 <td class="px-5 py-4">{i.end.split('-')?.reverse()?.join('/')}</td>
                                 <td class="px-5 py-4">{(i.total_to_pay) - (i.paid || 0) < 0 ? 0 : data._cn(((i.total_to_pay) - (i.paid || 0)).toFixed(2))}</td>
                                 </tr>
                                ))}
                              </tbody>
                          </table>
                      </div>
                    )}

                    {formData.interest_calculation_method=="price" && (
                        <div class="relative overflow-x-auto sm:rounded-lg">
                        <table class="w-full text-sm text-left rtl:text-right">
                            <thead class="text-[12px]  bg-white border-b border-black">
                                <tr>
                                    {[
                                        '#',
                                        'Data',
                                        'Valor',
                                        'Capital',
                                        'Juros',
                                        'Dívida',
                                    ].map((i,_i)=>(
                                        <th scope="col" class="px-6 py-3">
                                            {i}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>

                                {(topDetails.price_items || []).map((i,_i)=>(
                                    <tr class={`odd:bg-gray-100  even:bg-white ${_i==0 ? 'border-t !border-gray-400':''} __border-b __border-gray-200 text-[12px]`}>
                                        <td class="px-5 py-4">{_i+1}</td>
                                        <td class="px-5 py-4">{formData.installments[_i]?.end?.split('-')?.reverse()?.join('/')}</td>
                                        <td class="px-5 py-4">{data._cn(i.totalPayment)}</td>
                                        <td class="px-5 py-4">{data._cn(i.principalPaid)}</td>
                                        <td class="px-5 py-4">{data._cn(i.interestPaid)}</td>
                                        <td class="px-5 py-4">{data._cn(i.remainingBalance)}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                      )}

                </div>

                <div className="flex justify-between mt-10">

                   {(formData.insurance + formData.cost_of_preparation + formData.taxes) > 0 && <div>
                      <h2 className="mb-2 font-semibold text-[18px]">Despesas</h2>
                      <div className="flex flex-col gap-y-2 !text-[13px]">
                        {formData.cost_of_preparation > 0 && <div>
                            <span className="font-medium mr-2">1. Custo de Preparo:</span>
                            <label className="!text-gray-600">{formData.cost_of_preparation} MT</label>
                        </div>}
                        {formData.taxes > 0 && <div>
                            <span className="font-medium mr-2">1.1 Imposto de Selo:</span>
                            <label className="!text-gray-600">{formData.taxes} MT</label>
                        </div>}
                        {formData.insurance > 0 && <div>
                            <span className="font-medium mr-2">1.2 Seguro:</span>
                            <label className="!text-gray-600">{formData.insurance} MT</label>
                        </div>}
                      </div>
                   </div>}

                   <label className="mb-2 text-[16px]"><span className="font-semibold">Total a pagar:</span><span className="font-medium">{data._cn(topDetails.total_to_pay)} MT</span></label>

                </div>

              
                <div className="w-full mt-7 !text-[13px] text-gray-800">
                    E por corresponder à verdade, de livre e espontânea vontade assino o presente plano de pagamento, feito em duplicado,
                    com idêntico valor e teor, ambos com força de original.
                </div>

                <div className="signatures">
                    <div className="w-full flex flex-col items-center mt-[40px]">
                                        <span className="text-[14px] mb-1">{micro.id!=6 ? 'Maputo, ' : ''}{new Date(printingDocumentDate).toISOString().split('T')[0]?.split('-')?.reverse()?.join('/')}</span>
                                        <span className="font-semibold text-[14px]">O Devedor</span>

                                        <span className="flex border-b-2 border-black h-[50px] w-[200px]"></span>
                                        <span className="text-[15px] mt-2">{client.name}</span>
                    </div>
                </div>
              </div>
    </div>
  )
}
